import React from 'react';
import { FundacaoLogoTheme } from '../../libraries/FundacaoLogoThemes';

interface FundacaoLogoProps {
  height?: string | number;
  width?: string | number;
  theme?: FundacaoLogoTheme;
}
export const FundacaoLogo = (props: FundacaoLogoProps) => {
  const getPrimaryColor = () => {
    switch (props.theme) {
      case FundacaoLogoTheme.Branco:
        return '#FFFFFF';
      case FundacaoLogoTheme.Verde:
      default:
        return '#45a735';
    }
  };
  return (
    <div>
      <svg
        xmlns='http://www.w3.org/2000/svg'
        viewBox='0 0 165.016 87.627'
        height={props.height}
        width={props.width}
      >
        <g id='LogoFundacao' transform='translate(-887.507 -134.313)'>
          <g id='Grupo_2' data-name='Grupo 2'>
            <g id='Grupo_1' data-name='Grupo 1'>
              <path
                id='Caminho_1'
                data-name='Caminho 1'
                d='M961.053,174.72h-6.3l-.847,6.2h-2.627l2.172-15.966h9.556l-.323,2.326H955.76l-.682,5.087h6.295Z'
                fill={getPrimaryColor()}
              />
              <path
                id='Caminho_2'
                data-name='Caminho 2'
                d='M973.758,170.327l-1.053,7.564c-.166,1.3-.1,1.606.928,1.518l-.189,1.562c-1.37.22-3.3.527-2.949-1.76a4.712,4.712,0,0,1-4.057,1.891c-2.947,0-3.648-2-3.32-4.639l.832-6.136h2.441l-.854,6.136c-.245,1.693.514,2.726,1.922,2.726a3.11,3.11,0,0,0,3.065-2.793l.838-6.069Z'
                fill={getPrimaryColor()}
              />
              <path
                id='Caminho_3'
                data-name='Caminho 3'
                d='M976.263,170.282c1.772-.417,3.387,0,3.168,1.76a4.532,4.532,0,0,1,3.9-1.957c2.9,0,3.969,1.891,3.576,4.53l-.528,3.782c-.115.792.082,1.078,1.107.968l-.214,1.518c-2.1.417-3.6.131-3.261-2.4l.505-3.782a2.128,2.128,0,0,0-2.161-2.684,3.032,3.032,0,0,0-3.046,2.749l-.853,6.159h-2.4l1-7.368c.179-1.407.322-1.847-.989-1.737Z'
                fill={getPrimaryColor()}
              />
              <path
                id='Caminho_4'
                data-name='Caminho 4'
                d='M1001.178,164.888l-1.87,13.488c-.083.637.247.923,1.011.858l-.228,1.627c-1.562.286-3.071.11-2.852-1.65l.054-.439a4.5,4.5,0,0,1-3.959,2.309c-3.211,0-4.461-2.573-4.031-5.587.375-2.9,2.306-5.563,5.451-5.563A3.358,3.358,0,0,1,998,171.558l.935-6.67Zm-9.635,10.849c-.262,2.044.781,3.035,2.038,3.1a3.765,3.765,0,0,0,3.694-3.211c.394-1.76-.126-3.7-2.216-3.7-2.154,0-3.306,1.936-3.516,3.806'
                fill={getPrimaryColor()}
              />
              <path
                id='Caminho_5'
                data-name='Caminho 5'
                d='M1012.5,177.76c-.1.968-.253,1.605.947,1.474l-.229,1.627c-1.561.286-3.07.11-2.851-1.65l.054-.44a4.5,4.5,0,0,1-3.959,2.309c-3.255,0-4.462-2.572-4.03-5.586.547-3.518,3.171-5.454,6.651-5.388a10.13,10.13,0,0,1,4.319.99Zm-1.588-5.278a5.173,5.173,0,0,0-2.167-.44,3.761,3.761,0,0,0-3.916,3.452c-.271,1.936.174,3.453,2.109,3.453a3.729,3.729,0,0,0,3.551-3.342Z'
                fill={getPrimaryColor()}
              />
              <path
                id='Caminho_6'
                data-name='Caminho 6'
                d='M1019.879,181.08a4.558,4.558,0,0,1-4.313-4.4c-.33-4.354,3.211-6.664,6.4-6.664a4.261,4.261,0,0,1,4.556,3.827h-2.177c-.2-1.231-1.513-1.693-2.635-1.693a3.772,3.772,0,0,0-3.755,4.134,2.6,2.6,0,0,0,2.781,2.749,3.466,3.466,0,0,0,3.13-1.935h2.4a5.353,5.353,0,0,1-4.564,3.915l-.423,1.1c1.416.11,1.832,1.232,1.307,2.442-.853,1.8-3.646,1.8-4.953.813l.3-1.3c.572.6,2.421.9,2.815,0,.461-.879-.79-1.429-1.489-1.363Z'
                fill={getPrimaryColor()}
              />
              <path
                id='Caminho_7'
                data-name='Caminho 7'
                d='M1038.1,177.76c-.1.968-.251,1.605.948,1.474l-.228,1.627c-1.562.286-3.071.11-2.852-1.65l.054-.44a4.5,4.5,0,0,1-3.959,2.309c-3.255,0-4.461-2.572-4.03-5.586.546-3.518,3.171-5.454,6.651-5.388a10.13,10.13,0,0,1,4.319.99Zm-1.587-5.278a5.169,5.169,0,0,0-2.166-.44,3.762,3.762,0,0,0-3.917,3.452c-.271,1.936.174,3.453,2.109,3.453a3.73,3.73,0,0,0,3.552-3.342Zm-5.245-5.367c1.034-1.737,2.389-2.44,3.956-1.5.738.462,1.489.792,2.155-.286l1.121.572c-.858,1.738-2.256,2.441-3.732,1.539-.757-.417-1.647-.835-2.377.264-.345-.2-.736-.418-1.123-.594'
                fill={getPrimaryColor()}
              />
              <path
                id='Caminho_8'
                data-name='Caminho 8'
                d='M1046.055,181.125a4.7,4.7,0,0,1-4.888-4.421c-.331-4.376,2.989-6.707,6.424-6.641,2.447.066,4.686,1.473,4.91,4.42.33,4.355-3.1,6.707-6.446,6.642m1.145-8.973c-1.825,0-3.587,1.429-3.622,4.157a2.627,2.627,0,0,0,2.8,2.748c1.8,0,3.686-1.275,3.644-4.156a2.6,2.6,0,0,0-2.825-2.749'
                fill={getPrimaryColor()}
              />
            </g>
            <path
              id='Caminho_9'
              data-name='Caminho 9'
              d='M1049.645,195.106l.885-6.325h-7.323l-.885,6.325Zm-11,26.288h7.322l3.224-23.029h-7.322Zm-93.187-26.288.885-6.325h-7.324l-.885,6.325Zm-11,26.288h7.324L945,198.365h-7.324Zm-23.324-24.073c-.616,4.753,1.045,7.563,5.557,9.4l5.957,2.371c1.893.691,2.31,1.045,2.067,2.917-.369,2.414-1.308,3.059-5.473,3.059H909.113l-.9,6.324H919.53c8.816,0,11.777-2.077,12.671-8.894.552-4.3-.193-7.39-5.607-9.489l-5.632-2.145c-2.182-.815-2.585-1.142-2.3-3.052.334-2.128,1.119-2.589,2.753-2.7H933.5l.9-6.325h-10.78c-7.337,0-11.5,1.361-12.49,8.54m77.374,1.044h-1.42c-2.7,0-5.336,1.335-8.737,4.442v-4.442h-5.823L969.3,221.394h7.372l1.786-13.245a8.325,8.325,0,0,1,5.431-2.577h1.573l.055-.251a25.085,25.085,0,0,1,2.705-6.474Zm11.873,9.356c2.145-.172,3.141-.591,3.391-2.626a1.813,1.813,0,0,0-.239-1.389c-.334-.364-1.124-.438-2.291-.438-.216,0-.446,0-.69.007-3.447,0-4.3,1.176-4.974,4.9Zm9.374-7.434c1.119,1.288,1.494,3.1,1.148,5.528-.716,4.9-4.154,6.12-9.469,6.5l-6.319.476c.17,2.657,1.555,3.153,4.162,3.153a79.452,79.452,0,0,0,8.549-.49l.356-.091.042.366a27.214,27.214,0,0,0,.864,4.071l.084.276-.266.113a30.928,30.928,0,0,1-10.4,1.755c-4.244,0-7.163-.962-8.925-2.942-1.794-2.019-2.411-5.169-1.885-9.632,1.056-8.7,4.413-11.638,13.309-11.638,4.4,0,7.26.837,8.752,2.559m-49.935-2.559c-4.165,0-7.015.865-8.97,2.723-1.931,1.835-3.073,4.638-3.7,9.089-.629,4.423-.092,7.544,1.642,9.54,1.67,1.925,4.505,2.86,8.667,2.86a25.88,25.88,0,0,0,7.755-1.075l.19-.062.762-5.441-.487.082a51.272,51.272,0,0,1-7.04.4c-1.931,0-2.892-.238-3.428-.846-.664-.752-.79-2.219-.431-5.063.641-5.27,2.278-6.12,5.949-6.12,1.487,0,7.04.1,7.04.1l.721-5.161a30.3,30.3,0,0,0-8.669-1.027m66.3,5.365c-4.088,0-4.96.519-5.767,6.489-.415,3.06-.535,4.967.072,5.661a1.569,1.569,0,0,0,1.322.38c2.234-.045,4.008-1.224,6.3-3.249l1.3-9.281Zm12.657-14.266-4.613,32.567h-5.867v-3.64c-2.908,2.779-5.928,4.186-8.988,4.186a6.064,6.064,0,0,1-4.856-1.9c-1.727-1.971-2.233-5.449-1.549-10.638,1.35-9.724,4.981-11.678,10.4-11.678a48.3,48.3,0,0,1,6.776.516l1.334-9.417Z'
              fill={getPrimaryColor()}
            />
          </g>
          <g id='Grupo_3' data-name='Grupo 3'>
            <path
              id='Caminho_10'
              data-name='Caminho 10'
              d='M940.046,160.824c1.09-.721,2.176-1.456,3.188-2.262.261-.208.561-.442.789-.636a30.023,30.023,0,0,0,2.4-2.3c.225-.245.444-.332.612-.267.258.1.41.555.293,1.387a14.464,14.464,0,0,1-2.63,6.174l-.006-.019.006.018a9.565,9.565,0,0,1-4.654-2.091'
              fill='#00aaef'
            />
            <path
              id='Caminho_11'
              data-name='Caminho 11'
              d='M946.669,150.612c.787-.5,1.57-1.019,2.3-1.586.189-.146.4-.311.57-.447h0a21.376,21.376,0,0,0,1.738-1.626c.164-.172.321-.232.441-.184.184.073.291.4.2,1a10.289,10.289,0,0,1-1.929,4.394l0-.009,0,.009a6.907,6.907,0,0,1-3.323-1.548'
              fill='#ffb300'
            />
            <path
              id='Caminho_12'
              data-name='Caminho 12'
              d='M927.405,174.023c1.945-.89,3.887-1.8,5.73-2.855.476-.271,1.018-.573,1.437-.829h0a49.7,49.7,0,0,0,4.47-3.121c.428-.339.8-.425,1.058-.278.391.224.52,1,.118,2.316a23.73,23.73,0,0,1-5.83,9.316l0-.021,0,.021a15.589,15.589,0,0,1-6.983-4.55'
              fill='#ffb300'
            />
            <path
              id='Caminho_13'
              data-name='Caminho 13'
              d='M905.6,170.826c3.242-.293,6.492-.623,9.662-1.2.818-.149,1.749-.308,2.477-.466h0a73.775,73.775,0,0,0,7.972-2.231c.781-.272,1.365-.205,1.663.14.455.526.266,1.715-.952,3.418a35.42,35.42,0,0,1-12.941,10.52l.008-.033s0,.015-.007.031a24.513,24.513,0,0,1-7.882-10.179'
              fill={getPrimaryColor()}
            />
            <path
              id='Caminho_14'
              data-name='Caminho 14'
              d='M917.011,156.71a116.547,116.547,0,0,1-12.286-3.913h0c-1.082-.417-2.428-1-3.621-1.507-4.615-1.951-8.769-3.948-13.231-6.322-1.25,6.239.9,14.383,3.253,19.542,7.858.712,16.561,0,23.711-2.659,3.063-1.138,4.342-2.495,4.209-3.553-.086-.692-.786-1.273-2.036-1.588'
              fill='#00aaef'
            />
            <path
              id='Caminho_15'
              data-name='Caminho 15'
              d='M921.74,148.222a70.048,70.048,0,0,1-5.717-5.507c-.486-.527-1.071-1.222-1.594-1.829a80.737,80.737,0,0,1-4.933-6.573,22.908,22.908,0,0,0-3.966,11.625,32.334,32.334,0,0,0,13.684,4.7c1.975.145,3.028-.306,3.229-.955.133-.425-.1-.946-.7-1.459'
              fill='#ffb300'
            />
            <path
              id='Caminho_16'
              data-name='Caminho 16'
              d='M925.769,154.215c2.146.073,4.3.123,6.421.005.548-.031,1.17-.059,1.659-.1h0a48.546,48.546,0,0,0,5.4-.81c.532-.114.909-.023,1.077.228.258.383.042,1.147-.888,2.164a23.159,23.159,0,0,1-9.291,5.836c0-.01.007-.021.01-.031l-.01.03a16.333,16.333,0,0,1-4.373-7.32'
              fill={getPrimaryColor()}
            />
          </g>
        </g>
      </svg>
    </div>
  );
};

FundacaoLogo.defaultProps = {
  height: 87.627,
  theme: FundacaoLogoTheme.Verde
};
